export default "__VITE_ASSET__a467aaa6__"